'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RuleId$() {
  this.caF = null;
  this.caG = false;
}
export { $c_Lpresto_types$RuleId$ as $c_Lpresto_types$RuleId$ };
$p = $c_Lpresto_types$RuleId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RuleId$;
/** @constructor */
function $h_Lpresto_types$RuleId$() {
}
export { $h_Lpresto_types$RuleId$ as $h_Lpresto_types$RuleId$ };
$h_Lpresto_types$RuleId$.prototype = $p;
$p.a2F = (function() {
  if ((!this.caG)) {
    this.caF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0;
    this.caG = true;
  }
  return this.caF;
});
var $d_Lpresto_types$RuleId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RuleId$, "presto.types$RuleId$", ({
  a1h: 1,
  D: 1
}));
export { $d_Lpresto_types$RuleId$ as $d_Lpresto_types$RuleId$ };
var $n_Lpresto_types$RuleId$;
function $m_Lpresto_types$RuleId$() {
  if ((!$n_Lpresto_types$RuleId$)) {
    $n_Lpresto_types$RuleId$ = new $c_Lpresto_types$RuleId$();
  }
  return $n_Lpresto_types$RuleId$;
}
export { $m_Lpresto_types$RuleId$ as $m_Lpresto_types$RuleId$ };
//# sourceMappingURL=presto.types$-Rule-Id$.js.map
